<template>
  <td>{{ capitalizedAction }}</td>
</template>

<script>
  export default {
    name: "TableBlueLabelAction",
    props: ['action'],
    computed: {
      capitalizedAction() {
        switch (this.action) {
          case 'CREATE':
            return this.$t('td.createInvoice');
          case 'DEPOSIT':
            return this.$t('td.transfer');
          case 'WITHDRAW':
            return this.$t('td.transfer');
          case 'REMOVE':
            return this.$t('td.closeInvoice');
          default:
            throw new Error(`no such action: ${this.action}`);
        }
      },
    }
  }
</script>

<style scoped>
  td {
    text-align: center;
  }
</style>
